/**
 * Display formatting at the unit boundary. All maths is in km/h and
 * m/s; these helpers convert and format for the chosen unit system only here.
 */
import type { Units } from "./config";
import { kmhToKt, msToKt } from "./units";

/** Airspeed: "152 km/h" (metric) or "82 kt" (imperial). */
export const fmtSpeed = (kmh: number, units: Units): string =>
  units === "metric"
    ? `${kmh.toFixed(0)} km/h`
    : `${kmhToKt(kmh).toFixed(0)} kt`;

/** Sink rate: "0.55 m/s" (metric) or "1.1 kt" (imperial). */
export const fmtSink = (ms: number, units: Units): string =>
  units === "metric" ? `${ms.toFixed(2)} m/s` : `${msToKt(ms).toFixed(1)} kt`;

/** Glide ratio: "50.8:1". Unit-independent. */
export const fmtLD = (ld: number): string => `${ld.toFixed(1)}:1`;

export const speedAxisLabel = (units: Units): string =>
  units === "metric" ? "Airspeed (km/h)" : "Airspeed (kt)";

export const sinkAxisLabel = (units: Units): string =>
  units === "metric" ? "Sink rate (m/s)" : "Sink rate (kt)";
